import { useQuery } from '@tanstack/react-query';
import axiosInstance from "./index";

export type IVacancyCompany = {
  id: string;
  bin?: string
  phone?: string
} & CreateVacancyCompanyDTO

export type CreateVacancyCompanyDTO = {
  name: string;
  description: string;
  code: string;
  companyId: string | number
}

export interface IPartnerEmployee {
  id:number
  fullName:string
  email:string
  photo:string
  roles:string[]
}


export type BaseCountResponse = [IVacancyCompany[], number];

class VacancyCompanyApi {
  baseURL: string;

  constructor() {
    this.baseURL = `/api/vacancy-company`;
  }

  getAll = async (companyId?: number): Promise<BaseCountResponse> => {
    const response = await axiosInstance.get<BaseCountResponse>(`${this.baseURL}/find`, { params: { companyId } });
    return response.data;
  };

  getById = async (id: string): Promise<IVacancyCompany> => {
    const response = await axiosInstance.get<IVacancyCompany>(`${this.baseURL}/find/${id}`);
    return response.data;
  };

  getByCode = async (code: string): Promise<IVacancyCompany> => {
    const response = await axiosInstance.get<IVacancyCompany>(`${this.baseURL}/find-code/${code}`);
    return response.data;
  };

  getAllUsers = async (currentVacancyCompanyId: number): Promise<IPartnerEmployee[]> => {
    const response = await axiosInstance.get<IPartnerEmployee[]>(`${this.baseURL}/find-users/${currentVacancyCompanyId}`);
    return response.data;
  };
}


const vacancyCompanyService = new VacancyCompanyApi();

export const useVacancyCompanies = (companyId?: number) => {
  return useQuery({
    queryKey: ['vacancyCompanies', companyId],
    queryFn: () => vacancyCompanyService.getAll(companyId)
  });
};


export const useVacancyCompanyById = (id: string) => {
  return useQuery({
    queryKey: ['vacancyCompany', id],
    queryFn: () => vacancyCompanyService.getById(id),
    enabled: !!id,
  });
};

export const useVacancyCompanyByCode = (code: string) => {
  return useQuery({
    queryKey: ['vacancyCompanyByCode', code],
    queryFn: () => vacancyCompanyService.getByCode(code),
    enabled: !!code,
  });
};

export const useAllUsers = (currentVacancyCompanyId: number) => {
  return useQuery({
    queryKey: ['vacancyCompanyUsers', currentVacancyCompanyId],
    queryFn: () => vacancyCompanyService.getAllUsers(currentVacancyCompanyId),
    enabled: !!currentVacancyCompanyId,
  });
};

export const VacancyCompanyHook = {
  useVacancyCompanies,
  useVacancyCompanyById,
  useVacancyCompanyByCode,
  useAllUsers,
}